import { createContext, useState } from 'react';

export const FilterExpiredProductContext = createContext();
export const FilterExpiredProductProvider = ({ children }) => {
    const [isUserNameSelected, setUserNameSelectedSelected] = useState(false);
    const [isProductNameSelected, setIsProductNameSelected] = useState(false);
    const [isManufacturerSelected, setIsManufacturerSelected] = useState(false);
    const [isLotSelected, setIsLotSelected] = useState(false);
    const [isExpirationDateSelected, setIsExpirationDateSelected] = useState(false);
    const [isDaysToExpireSelected, setIsDaysToExpireSelected] = useState(false);
    const [isGroupSelected, setIsGroupSelected] = useState(false);
    const [isStatusProductSelected, setIsStatusProductSelected] = useState(false);
    const [isLostProductSelected, setIsLostProductSelected] = useState(false);
    const [isBarCodeSelected, setIsBarCodeSelected] = useState(false);
    const [isProductQuantitySelected, setIsProductQuantitySelected] = useState(false);
    const [isProductSoldSelected, setIsProductSoldSelected] = useState(false);
    const [isProductBalanceSelected, setIsProductBalanceSelected] = useState(false);
    const [isProductLocationSelected, setIsProductLocationSelected] = useState(false);
    const [filterData, setFilterData] = useState({});
    const [isFilter, setIsFilter] = useState(false);
    const [filterResponseData, setFilterResponseData] = useState([]);
    const [storeId, setStoreId] = useState(null);

    const clearFilterState = () => { setIsFilter(false) }
    const resetState = () => {
        setUserNameSelectedSelected(false)
        setIsProductNameSelected(false)
        setIsManufacturerSelected(false)
        setIsLotSelected(false)
        setIsExpirationDateSelected(false)
        setIsDaysToExpireSelected(false)
        setIsGroupSelected(false)
        setIsStatusProductSelected(false)
        setIsLostProductSelected(false)
        setIsBarCodeSelected(false)
        setIsProductQuantitySelected(false)
        setIsProductSoldSelected(false)
        setIsProductBalanceSelected(false)
        setIsProductLocationSelected(false)
    }
    return (
        <FilterExpiredProductContext.Provider value={{ 
            isProductNameSelected, setIsProductNameSelected,
            isManufacturerSelected, setIsManufacturerSelected,
            isLotSelected, setIsLotSelected,
            isExpirationDateSelected, setIsExpirationDateSelected,
            isDaysToExpireSelected, setIsDaysToExpireSelected,
            isGroupSelected, setIsGroupSelected,
            isStatusProductSelected, setIsStatusProductSelected,
            isUserNameSelected, setUserNameSelectedSelected,
            isLostProductSelected, setIsLostProductSelected,
            isBarCodeSelected, setIsBarCodeSelected,
            isProductQuantitySelected, setIsProductQuantitySelected,
            isProductSoldSelected, setIsProductSoldSelected,
            isProductBalanceSelected, setIsProductBalanceSelected,
            isProductLocationSelected, setIsProductLocationSelected,
            resetState,
            filterData, 
            setFilterData,
            filterResponseData, 
            setFilterResponseData,
            isFilter, 
            setIsFilter,
            clearFilterState,
            storeId,
            setStoreId
         }}>
            {children}
        </FilterExpiredProductContext.Provider>
    );
};
